export default {"src":"/_next/static/media/Candle-price-chart.90deaaad.svg","height":185,"width":534};